import { Icon20Dropdown } from '@vkontakte/icons';
import classNames from 'clsx';
import { ReactComponent as IconArrow } from 'img/icons/mobile/arrow.svg';
import { ReactComponent as IconDropdown } from 'mrg-icons/src/mailru/navigation/drop_down.svg';
import React, { MouseEvent, ReactElement, useCallback } from 'react';
import { isModifiedSharingWindow } from 'reactApp/appHelpers/featuresHelpers';

import styles from './SharingDropdown.css';
import { EDropdownColors, IProps } from './SharingDropdown.types';

export const SharingDropdown = React.memo(function SharingNewDropdown(props: IProps): ReactElement {
    const { onClick, color = EDropdownColors, isActive, disabled, isPhone, isUserDropdown, inInput } = props;

    const handleClick = useCallback(
        (e: MouseEvent): void => {
            e.stopPropagation();
            onClick?.(e);
        },
        [onClick]
    );
    const desktopIcon = () => {
        return isModifiedSharingWindow ? (
            <Icon20Dropdown width={12} height={16} className={styles.icon} />
        ) : (
            <IconDropdown width={12} height={15} className={styles.icon} />
        );
    };

    return (
        <div
            className={classNames({
                [styles.root]: true,
                [styles[`root_color_${color}`]]: color,
                [styles.root_opened]: isActive,
                [styles.root_disabled]: disabled,
                [styles.root_in_input]: inInput,
                [styles.root_phone]: isPhone,
                [styles.root_in_user]: isUserDropdown,
            })}
            onClick={handleClick}
            data-qa-value={props.qaValue}
        >
            <div className={styles.container}>
                <div className={styles.text}>{props.value}</div>
                {isPhone ? <IconArrow className={styles.icon} /> : desktopIcon()}
            </div>
        </div>
    );
});
